import * as OM from '@/model';
import * as VM from '@/viewmodel';

class _StorageServices  {
    
    private readFromLocalStorage<T>(lsName: string): T | null {
        let data = window.localStorage.getItem(lsName);
        if(data){
            return JSON.parse(data);
        } else {
            return null;
        }
    }
    
    getUser() {
        return this.readFromLocalStorage<OM.User>('User');
    }
    setUser(response: OM.User) {
        window.localStorage.setItem('User', JSON.stringify(response));
    }
    
    getSuperAdminToken() {
        return window.localStorage.getItem('superAdminToken');
    }
    setSuperAdminToken(token: string) {
        window.localStorage.setItem('superAdminToken', token);
    }
    removeSuperAdminToken() {
        window.localStorage.removeItem('superAdminToken');
    }
    
    getSelectedCommessa() {
        return this.readFromLocalStorage<string>('SelectedCommessa');
    }
    setSelectedCommessa(response: string) {
        window.localStorage.setItem('SelectedCommessa', JSON.stringify(response));
    }


    setOpTableFilters(key: string, filters: any){
        window.localStorage.setItem('_op_' + key, JSON.stringify(filters));
    }
    getOpTableFilters(key: string){
        return this.readFromLocalStorage<any>('_op_' + key);
    }

    setOpTableColWidths(name: string, widths: (number | null)[]) {
        window.localStorage.setItem('_op_cols_' + name, JSON.stringify(widths));
    }
    getOpTableColWidths(name: string): (number | null)[] | null {
        return this.readFromLocalStorage<(number | null)[]>('_op_cols_' + name);
    }

    // scoped per utente: ogni utente vede solo i file che ha scaricato lui
    getDownloadedFiles(userIdentifier: string) {
        return this.readFromLocalStorage<VM.DownloadedQrFileVm[]>('DownloadedFiles_' + userIdentifier) || [];
    }
    setDownloadedFiles(userIdentifier: string, files: VM.DownloadedQrFileVm[]) {
        window.localStorage.setItem('DownloadedFiles_' + userIdentifier, JSON.stringify(files));
    }
}

export let StorageServices = new _StorageServices();